import { render, staticRenderFns } from "./ExpandableHtmlBlock.vue?vue&type=template&id=d002d3c6&scoped=true&"
import script from "./ExpandableHtmlBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExpandableHtmlBlock.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ExpandableHtmlBlock.vue?vue&type=style&index=0&id=d002d3c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d002d3c6",
  null
  
)

export default component.exports